/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type BusinessDetailsDTO = {
  additionalInfoPhysicalBusinessAddress?: string;
  businessDescription?: string;
  businessSector?: string;
  businessTradingName?: string;
  businessType?: string;
  localGovernmentArea?: string;
  physicalBusinessAddress?: string;
  state?: string;
  verificationStatus?: BusinessDetailsDTO.verificationStatus;
};

export namespace BusinessDetailsDTO {
  export enum verificationStatus {
    PENDING = "PENDING",
    SUCCESS = "SUCCESS",
    FAILED = "FAILED",
  }
}
